const ALWAYS_ON_OUTLINE_EMPHASIS = 5;
export function selectOutlineTargetEnemy(_game) {
  return { enemy: null, emphasis: ALWAYS_ON_OUTLINE_EMPHASIS };
}

export function updateEnemyTargetOutlines(game) {
  for (const enemy of game.enemies) {
    if (!enemy?.group) continue;
    if (!enemy.alive) {
      enemy.setTargetOutlineActive(false, 0);
      continue;
    }
    enemy.setTargetOutlineActive(true, ALWAYS_ON_OUTLINE_EMPHASIS);
  }
  game._outlineTargetEnemy = null;
}
